import { render, staticRenderFns } from "./Framed.vue?vue&type=template&id=137532ab&"
import script from "./Framed.vue?vue&type=script&lang=js&"
export * from "./Framed.vue?vue&type=script&lang=js&"
import style0 from "./Framed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports